// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"359417e9","187":"b530a8ec","317":"0a401511"}[chunkId] + ".chunk.css";
};